import * as gochiChildFoodListActions from '../actions/GochiChildFoodLists';

const initialState = {
  lists: [],
  offset: 0,
  limit: 10,
  totalCount: 7,
  detail: {
    group: [
      {
        groupId: 1,
        groupName: '店舗A'
      }
    ],
    childFoodId: 1,
    childFoodName: 1,
    shop: [
      {
        shopId: 1,
        shopName: '店舗A'
      }
    ],
    menuChild: 'オムライス',
    childFoodDescription: 'ふわっふわなオムライスです。',
    childFoodImage:
      'https://gcms-manage-mock-image.s3-ap-northeast-1.amazonaws.com/menu/omu.png',
    createdAt: '2019-01-01 12:00:00',
    updatedAt: '2019-02-01 12:00:00'
  },
  error: false,
  status: 200,
  error_message: ''
};

const gochiChildFoodLists = (state = initialState, action) => {
  switch (action.type) {
    case gochiChildFoodListActions.GET_GOCHI_CHILD_FOOD_SUCCESS:
      return Object.assign({}, state, action.payload);
    case gochiChildFoodListActions.GET_GOCHI_CHILD_FOOD_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    case gochiChildFoodListActions.GET_GOCHI_CHILD_FOOD_DETAIL_SUCCESS:
      return Object.assign({}, state, { detail: action.payload });
    case gochiChildFoodListActions.GET_GOCHI_CHILD_FOOD_DETAIL_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default gochiChildFoodLists;
